import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Creates (or reuses) the draft's Stripe recipient and returns a single-use
 * hosted-form URL; the browser navigates there and comes back to `returnUrl`.
 */
export const startStripeRefundRecipientOnboarding = {
  name: "startStripeRefundRecipientOnboarding" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    returnUrl: z.string().url(),
    /** Bank account country, ISO 3166-1 alpha-2 uppercase; defaults to US. */
    country: z
      .string()
      .regex(/^[A-Z]{2}$/)
      .optional(),
  }),
  output: z.object({ providerAccountId: z.string(), url: z.string().url() }),
};
